var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeafAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9255 7C16.2556 7 10.1815 8.36514 11.0914 14.5994C11.306 16.07 11.4419 15.8063 11.9596 14.8023C11.9822 14.7584 12.0056 14.7131 12.0297 14.6665C12.5933 13.5772 13.5171 12.2613 14.9697 10.8518C15.2626 10.5676 15.7374 10.5676 16.0303 10.8518C16.3232 11.136 16.3232 11.5968 16.0303 11.881C14.6829 13.1885 13.8567 14.3792 13.3703 15.3195C12.8765 16.2739 12.751 16.9334 12.75 17.1854C13.6102 17.6681 14.6005 17.7276 15.2321 17.6392C19.8903 17.1326 20.408 13.0796 20.408 11.0531C20.408 9.43184 20.9255 8.5199 21.4431 8.01327C21.9607 7.67551 22.5818 7 20.9255 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5698 12.7932C4.78513 11.805 7.74421 11.0893 9.51741 12.7071C9.46383 13.3688 9.4886 14.0706 9.59451 14.8116C9.64874 15.191 9.71208 15.5697 9.80631 15.8671C9.84677 15.9948 9.94311 16.2795 10.1609 16.5434C10.2362 16.6346 10.3445 16.7461 10.4911 16.8477C10.1817 17.2744 9.68399 17.5863 9.03047 17.7742C6.03364 18.7366 4.58464 16.3876 4.01878 15.1423C3.5661 14.1461 2.99421 13.7272 2.53547 13.5574C2.12389 13.4914 1.55455 13.2461 2.5698 12.7932Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafAlt2);
export default __webpack_public_path__ + "static/media/leaf-alt-2.ede0fc5354124c9f54a0c0cb694857d3.svg";
export { ForwardRef as ReactComponent };